// AuthForm.jsx
import React, { useState, useContext } from 'react';
import LoginForm from './LoginForm/LoginForm';
import RegistrationForm from './RegistrationForm/RegistrationForm';
import Tab from './Tab/Tab';
import AuthClose from './AuthClose/AuthClose';
import './AuthForm.css';
import { useNavigate } from 'react-router-dom';
import { resetPasswordRequest } from "../../../../../http/UserAPI";
import SocialLogin from './SocialLogin/SocialLogin';
import { tgInit } from '../../../../../http/UserAPI';
import { MAIN_MENU_ROUTE } from '../../../../../constants/constants';
import { Context } from '../../../../..';


const AuthForm = ({ onClose }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [registrationStep, setRegistrationStep] = useState(1); // добавляем состояние для шага регистрации
  const navigate = useNavigate()
  const { user } = useContext(Context)

  const handleForgotPassword = () => {
    setIsForgotPassword(true);
    setIsLogin(false);

  };

  const handleBackToLogin = () => {
    setIsForgotPassword(false);
    setIsLogin(true);
  };

  const onTGRegister = (data) => {
    user.setDisplayProfileFill(true)
  }

  const onTGLogin = () => {
    console.log(user.user)
    navigate('/')
    onClose()
  }

  const handleAuthSuccess = async (userData) => {
    try {
      console.log("📩 Данные от Telegram:", userData);

      // ❌ Тут tgInit() возвращает null, если сервер ответил не так, как ожидалось
      const serverResponse = await tgInit(userData);
      console.log("🔄 Ответ от сервера после tgInit:", serverResponse);

      if (!serverResponse || typeof serverResponse !== "object") {
        console.error("❌ Ошибка: сервер вернул некорректный ответ!", serverResponse);
        return;
      }

      if (!serverResponse.user) {
        console.error("❌ Ошибка: В ответе нет `user`!", serverResponse);
        return;
      }

      console.log("✅ Корректный ответ от сервера:", serverResponse);

      const authorizedUser = serverResponse.user;

      // ✅ Теперь точно сохранит юзера
      user.setUser(authorizedUser);
      user.setIsAuth(true);
      localStorage.setItem("user", JSON.stringify(authorizedUser));

      if (serverResponse.status === "register") {
        onTGRegister();
      } else {
        onTGLogin();
      }
    } catch (error) {
      console.error("❌ Ошибка авторизации через Telegram:", error);
    }
  };





  const handleAuthError = (errorMessage) => {
    alert("Ошибка: " + errorMessage);
  };

  return (
    <div className="auth-form-wrapper">
      <div className="auth__form">
        <form>
          <div className="auth__tabs">
            <div>
              {!isForgotPassword && (
                <>
                  {((isLogin || registrationStep === 1) && !isForgotPassword) && ( // проверка на шаг регистрации
                    <>
                      <Tab onTGLogin={onTGLogin} onTGRegister={onTGRegister} isActive={isLogin} onClick={() => setIsLogin(true)} label="Вход" />
                      <Tab onTGLogin={onTGLogin} onTGRegister={onTGRegister} isActive={!isLogin} onClick={() => setIsLogin(false)} label="Регистрация" />
                    </>
                  )}
                </>
              )}
            </div>
            <AuthClose onClick={onClose} />
          </div>

          {isForgotPassword ? (
            <LoginForm
              isForgotPassword={isForgotPassword}
              onForgotPassword={handleForgotPassword}
              onBackToLogin={handleBackToLogin}
              onClose={onClose} // Передаём функцию закрытия
            />

          ) : (
            isLogin ? (
              <LoginForm
                isForgotPassword={isForgotPassword}
                onForgotPassword={handleForgotPassword}
                onBackToLogin={handleBackToLogin}
                onClose={onClose} // Передаём функцию закрытия
              />

            ) : (
              <RegistrationForm onClose={onClose}
                onStepChange={setRegistrationStep}
              />
            )
          )}
        </form>
        <SocialLogin
          onAuthSuccess={handleAuthSuccess}
          onAuthError={handleAuthError}
          onClose={onClose} />
      </div>
    </div>
  );
};

export default AuthForm;
